/**
 * 品类树(前端从扁平 `CategoryNodeDTO[]` 派生 L1/L2)。
 * 后端 `/guide/categories` 返回扁平列表:L1 = 无 parentId;L2 = parentId===L1.id。
 * L1 tab 与 L2 chips 均按 sortOrder 排序。
 */
import type { CategoryNode } from '@/api/guide';

function byOrder(a: CategoryNode, b: CategoryNode): number {
  return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
}

/** 一级品类(tab 条数据源)。 */
export function l1Nodes(flat: CategoryNode[]): CategoryNode[] {
  return flat.filter((n) => !n.parentId).sort(byOrder);
}

/** 按 id 找 L1 节点(品类详情页标题/面包屑)。 */
export function findL1(flat: CategoryNode[], id?: string): CategoryNode | undefined {
  if (!id) return undefined;
  return flat.find((n) => n.id === id);
}

/** 某 L1 的二级品类(L2 chips,前端过滤用)。 */
export function l2Children(flat: CategoryNode[], l1Id?: string): CategoryNode[] {
  if (!l1Id) return [];
  return flat.filter((n) => n.parentId === l1Id).sort(byOrder);
}
